import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceActions from '../actions/ecommerce-customers.action';
import {LoadEcommerceCustomer} from '../actions/ecommerce-customers.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceCustomers} from "../actions";
import {CustomersService} from "../../websites/website/ecommerce/customers/customers.service";

@Injectable()
export class EcommerceCustomersEffect {

  loadEcommerceCustomers$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_CUSTOMERS),
    mergeMap((action: LoadEcommerceCustomers) => {
      const {websiteId, ...params} = action.payload;
      return this._customersService.getCustomers(websiteId, params)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceCustomersSuccess({
                websiteId,
                entities: response.data,
                customersCount: response.data.customersTotals
              });
            }
            return new EcommerceActions.LoadEcommerceCustomersFails({websiteId});
          })
        );
    })
  ));
  loadEcommerceCustomer$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_CUSTOMER),
    mergeMap((action: LoadEcommerceCustomer) => {
      const {websiteId, id} = action.payload;
      return this._customersService.getCustomerById(websiteId, id)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceCustomerSuccess({
                websiteId,
                entities: response.data,
              });
            }
            return new EcommerceActions.LoadEcommerceCustomerFails({websiteId});
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _customersService: CustomersService,
  ) {
  }


}
